import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD-Kx97D72jHU6XFeNJrBX82DkSUhzLTwI",
  authDomain: "ai-nachmed.firebaseapp.com",
  projectId: "ai-nachmed",
  storageBucket: "ai-nachmed.firebasestorage.app",
  messagingSenderId: "578766667404",
  appId: "1:578766667404:web:f3b77913a077e8696805a9",
  measurementId: "G-F0PHY79G0S"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Auth
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
// Ensure the Google popup always asks to choose account
try {
  googleProvider.setCustomParameters({ prompt: 'select_account' });
} catch (e) {
  // ignore if environment does not support
}

// Initialize Analytics
let analytics = null;
let analyticsInitialized = false;

// Функція для отримання analytics з перевіркою ініціалізації
export const getAnalyticsInstance = () => {
  return analytics;
};

export const isAnalyticsInitialized = () => {
  return analyticsInitialized;
};

// Перевіряємо, чи підтримується Analytics в поточному середовищі
const initAnalytics = async () => {
  try {
    const supported = await isSupported();
    
    if (supported) {
      analytics = getAnalytics(app);
      analyticsInitialized = true;
    } else {
      // Для тестування на localhost - примусова ініціалізація
      try {
        analytics = getAnalytics(app);
        analyticsInitialized = true;
      } catch (forceError) {
        // Force initialization failed
      }
    }
  } catch (error) {
    console.error('Error initializing Firebase Analytics:', error);
  }
};

// Ініціалізуємо Analytics
initAnalytics();

export { analytics };
export { auth, googleProvider };

// Firebase Cloud Messaging
let messaging = null;

const initMessaging = async () => {
  try {
    // Messaging only works in secure contexts (HTTPS or localhost)
    if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
      messaging = getMessaging(app);
    }
  } catch (error) {
    console.error('Error initializing Firebase Messaging:', error);
  }
};

initMessaging();

// Get FCM token for push notifications
export const getFCMToken = async (vapidKey) => {
  try {
    if (!messaging) {
      console.warn('Firebase Messaging not initialized');
      return null;
    }

    // Register service worker
    const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');

    const token = await getToken(messaging, {
      vapidKey: vapidKey,
      serviceWorkerRegistration: registration,
    });

    if (token) {
      return token;
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
};

// Listen for foreground messages
export const onForegroundMessage = (callback) => {
  if (!messaging) {
    console.warn('Firebase Messaging not initialized');
    return () => {};
  }

  return onMessage(messaging, (payload) => {
    console.log('Foreground message received:', payload);
    callback(payload);
  });
};

export { messaging };
export default app;
